export const focusFirstErrorField = ({
  setFocus,
  errors,
  fields,
}: {
  setFocus: Function;
  errors: { [key: string]: any };
  fields: string[];
}) => {
  for (const key of fields) {
    if (errors[key]) {
      try {
        setFocus(key);
      } catch (error) {}
      break;
    }
  }
};
